<template>
<div id="joinus">
  <el-row :gutter="10">
    <el-col :span="4">
      <img src="@/assets/img/welcome.png" alt="">
    </el-col>
    <el-col :span="20">
      <div class="introTitle" v-show="isShow">
        加入我们
      </div>
      <div class="introSubTitle">
        <span>申请博士、硕士研究生</span>
      </div>
      <span class="introInfo">
    <ul>
      <li>博士专业与研究方向： 摄影测量与遥感、地图学与地理信息系统、地图制图学与地理信息工程、资源与环境；</li>
      <li>硕士专业与研究方向： 摄影测量与遥感、测绘工程、地图学与地理信息系统、地图制图学与地理信息工程、计算机科学与技术、资源与环境；</li>
    </ul>
  </span>
      <div class="introSubTitle">
        <span>申请博士后（常年招收）</span>
      </div>
      <span class="introInfo">
    <ul>
      <li>专业与研究方向： 摄影测量与遥感、地图学与地理信息系统、地图制图学与地理信息工程；</li>
      <li>具有博士学位或博士论文已答辩即将获得博士学位，具有测绘遥感、地理信息、导航定位、大数据挖掘、智能系统、计算机、电子信息、数学等相关领域专业背景，欢迎跨学科博士研究人员申请；</li>
      <li>以第一作者身份在本领域国际学术期刊至少发表过1篇研究论文；</li>
      <li>具有独立开展相关研究的能力，可协助指导研究生和完成重大项目的申报；</li>
      <li>符合武汉大学博士后政策http://postdoc.whu.edu.cn/indexone.shtml；</li>
      <li>工资及福利待遇按国家博士后相关规定和武汉大学相关规定执行，在此基础上根据具体贡献有20%~50%的提升；</li>
    </ul>
  </span>
      <div class="introSubTitle">
        <span>招聘科研助理（常年招收）</span>
      </div>
      <span class="introInfo">
    <ul>
      <li>专业与研究方向：遥感影像处理、地理信息系统、计算机视觉、应用数学、时空数据挖掘、嵌入式软件、空间数据库、行政管理等方面的本科、硕士与博士；</li>
      <li>条件面议，薪资高于外面行业公司薪酬标准，并根据成果有奖励</li>
    </ul>
  </span>
      <div class="introSubTitle">
        <span>科研条件</span>
      </div>
      <span class="introInfo">
    <ul>
      <li>招生要求：对科学探索或动手实践具有浓厚的兴趣，学生原有专业及学校不设限制，博士和硕士各种类型均可；</li>
      <li>团队平台：学习交流的大平台，一线梯队，大团队合作，政产学研用，知识覆盖面广，团队的相关研究得到了国家科技部、国防科工局、军委科技委、装备发展部等部门的重大项目支持，拥有充足的经费保障；</li>
      <li>学生培养：培养学生学术科研、中英文论文写作、国内外学术交流、软件研制、项目组织管理等能力；鼓励参加国际交流；和国内科研机构和企业长期合作，进行联合培养；具有奖学金、工资、科研项目补贴等成果奖励。</li>
    </ul>
  </span>
      <div class="introSubTitle">
        <span>眭海刚教授联系方式</span>
      </div>
      <el-row :gutter="50">
        <el-col :span="12" class="introInfo">
          <i class="el-icon-qq">QQ：</i>
          <span>1669378879</span>
        </el-col>
        <el-col :span="12" class="introInfo">
          <i class="el-icon-message">邮箱：</i>
          <span>
            haigang_sui@263.net
          </span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  name: "JoinUs",
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    this.isShow = this.$route.query.isShow
    console.log(this.isShow)
  }
}
</script>

<style lang="less" scoped>
#joinus {
  margin-top: 20px;
  .introTitle{
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    font-weight: bolder;
    color: #076498;
    border-bottom: 1px solid #b1b1b1;
  }
  .introSubTitle{
    height: 25px;
    font-size: 16px;
    margin: 10px 0;
    padding: 0 10px;
    border-left: 3px solid #0098ec;
  }
  .introInfo {
    display: block;
    text-align: justify;
    line-height: 26px;
    padding: 5px;
    font-size: 14px;
    color: #454545;
    ul{
      margin: 0;
      li{
        text-indent: 0px;
      }
    }
  }
}
</style>
